import * as Yup from "yup";
import { REQUIRED_FIELD } from "../../constants/validator-messages";

export type TJupixIntegrationConfigFieldValues = {
  clientId: string;
  clientSecret: string;
};

export const jupixIntegrationInitialValues: TJupixIntegrationConfigFieldValues = {
  clientId: "",
  clientSecret: "",
};

export const jupixIntegrationConnectValidationSchema = Yup.object().shape({
  clientId: Yup.string().required(REQUIRED_FIELD),
  clientSecret: Yup.string().required(REQUIRED_FIELD),
});
